import React, {FC} from 'react';

import {RendererOf} from '../../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {DropdownItem} from '../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItem';
import {DropdownItemIcon} from '../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemIcon';
import {DropdownItemMultiline} from '../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemMultiline';
import {IconName} from '../../../../../libs/shared/ui/src/components/icon/icon';
import {VisualSizesEnum} from '../../../../../libs/shared/ui/src/styles/commonStyles';
import {computeCustomFieldIconName, renderCustomFieldType} from '../../../../helpers/customFieldViewHelpers';
import {CustomFieldModel} from '../../../../models/api/customFieldModel';

/*
 * Props.
 */

interface CustomFieldItemProps {
  item: CustomFieldModel;
  isDisabled?: boolean;
  isChecked?: boolean;
  onSelect: (model: CustomFieldModel) => void;
  renderCustomFieldName?: RendererOf<CustomFieldModel>;
  renderSpecialCustomFieldType?: RendererOf<CustomFieldModel>;
  renderCustomFieldIcon?: (customField: CustomFieldModel) => IconName | undefined;
}

/*
 * Component.
 */

export const CustomFieldItem: FC<CustomFieldItemProps> = (props) => {
  const {
    item,
    isDisabled,
    isChecked,
    renderCustomFieldName,
    renderCustomFieldIcon,
    renderSpecialCustomFieldType,
    onSelect,
  } = props;
  const renderTitle = (customField: CustomFieldModel) => {
    if (renderCustomFieldName) {
      return renderCustomFieldName(customField);
    }
    return customField.name;
  };
  const iconName = renderCustomFieldIcon
    ? renderCustomFieldIcon(item)
    : computeCustomFieldIconName(item.type, VisualSizesEnum.SMALL);

  const customFieldType = renderSpecialCustomFieldType
    ? renderSpecialCustomFieldType(item)
    : renderCustomFieldType(item.type);

  return (
    <DropdownItem
      onSelect={isChecked ? undefined : () => onSelect(item)}
      isDisabled={!isChecked && isDisabled}
      isChecked={isChecked}
    >
      <DropdownItemIcon iconName={iconName} iconSize={16} label={null} />
      <DropdownItemMultiline title={renderTitle(item)} subtitle={customFieldType} />
    </DropdownItem>
  );
};
